import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Error, useGetList } from 'react-admin';

import SearchBar from '@src/custom/search-bar';
import Table from './attachment-selector-table';

const PER_PAGE = 15;

const AttachmentSelectorModal = (props) => {
    const { onAttachmentSelected, articleSuitable } = props;

    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState(null);

    const filter = searchTerm ? { query: searchTerm } : {};
    if (articleSuitable) {
        filter.article_suitable = true;
    }

    const { data, error, isPending, total } = useGetList(
        'attachments',
        {
            pagination: { page, perPage: PER_PAGE },
            sort: { field: 'id', order: 'DESC' },
            filter,
        },
    );

    // Debug logging to understand what's happening
    useEffect(() => {
        console.warn('AttachmentSelectorModal: useGetList result', {
            data,
            error,
            isPending,
            total,
            page,
            searchTerm,
        });
    }, [data, error, isPending, total, page, searchTerm]);

    const handlePageChange = useCallback((page) => {
        setPage(page);
    }, [setPage]);

    const handleSearchChange = useCallback((searchTerm) => {
        setSearchTerm(searchTerm);
    }, [setSearchTerm]);

    if (error) {
        return <Error error={error} errorInfo={{ componentStack: null }} />;
    }

    const attachmentsData = {
        attachments: data || [],
        page,
        total: total || 0,
        perPage: PER_PAGE,
    };

    return (
        <>
            <SearchBar onChange={handleSearchChange} />
            <Table
                attachmentsData={attachmentsData}
                loading={isPending}
                onAttachmentSelected={onAttachmentSelected}
                onPageChange={handlePageChange}
            />
        </>
    );
};

AttachmentSelectorModal.propTypes = {
    onAttachmentSelected: PropTypes.func.isRequired,
};

export default React.memo(AttachmentSelectorModal);
